import { render, staticRenderFns } from "./PublicPrakerja.vue?vue&type=template&id=188def00&scoped=true"
import script from "./PublicPrakerja.vue?vue&type=script&lang=js"
export * from "./PublicPrakerja.vue?vue&type=script&lang=js"
import style0 from "./PublicPrakerja.vue?vue&type=style&index=0&id=188def00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188def00",
  null
  
)

export default component.exports